import { render } from "./Vendor_Statement.vue?vue&type=template&id=2e5efd9e&scoped=true"
import script from "./Vendor_Statement.vue?vue&type=script&lang=js"
export * from "./Vendor_Statement.vue?vue&type=script&lang=js"

import "./Vendor_Statement.vue?vue&type=style&index=0&id=2e5efd9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5efd9e"]])

export default __exports__